(() => {
  const convertMeasurement = (text, base, target) => {
    const source = text.trim();
    const number = '-?\\d+(?:\\.\\d+)?';
    const unit = '(cm|in|\")';
    const format = (value, from) => from === target ? String(value) : String(Math.round((target === 'in' ? Number(value) / 2.54 : Number(value) * 2.54) * 100) / 100);
    const normalise = value => value === '"' ? 'in' : value.toLowerCase();
    if (/^-?\d+(?:\.\d+)?$/.test(source)) return `${format(source, base)} ${target}`;
    const single = source.match(new RegExp(`^([<>≤≥]\\s*)?(${number})\\s*${unit}$`, 'i'));
    if (single) return `${single[1] || ''}${format(single[2], normalise(single[3]))} ${target}`;
    const range = source.match(new RegExp(`^(${number})\\s*${unit}?\\s*([-–])\\s*(${number})\\s*${unit}$`, 'i'));
    if (range) {
      const from = normalise(range[5]);
      if (range[2] && normalise(range[2]) !== from) return source;
      return `${format(range[1], from)} ${range[3]} ${format(range[4], from)} ${target}`;
    }
    return source;
  };
  if (customElements.get('rt-product-guide')) return;
  customElements.define('rt-product-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        if (event.target.closest('[data-guide-open]') && this.dialog?.showModal) {
          event.preventDefault(); this.open(event.target.closest('[data-guide-open]'));
        }
        if (event.target.closest('[data-guide-close]')) this.dialog?.close();
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.selectTab(tab);
      });
      this.dialog?.addEventListener('close', () => this.opener?.focus());
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        let i = tabs.indexOf(tab);
        i = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        this.selectTab(tabs[i]); tabs[i].focus();
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-guide-unit]')) return;
        event.stopPropagation();
        const table = event.target.closest('[data-guide-table]');
        const from = table.dataset.baseUnit;
        const to = event.target.value;
        table.querySelectorAll('[data-guide-current-unit]').forEach(label => label.textContent = to);
        table.querySelectorAll('[data-guide-number]').forEach(cell => {
          const original = cell.dataset.guideNumber.trim();
          // Only complete measurements match; arbitrary text and mixed-unit ranges stay intact.
          cell.textContent = convertMeasurement(original, from, to);
        });
      });
      this.querySelectorAll('[data-guide-unit]').forEach(select => select.dispatchEvent(new Event('change', { bubbles: true })));
      const first = this.querySelector('[role="tab"]');
      if (first) this.selectTab(first);
    }
    open(opener) { this.opener = opener; this.dialog?.showModal(); }
    selectTab(tab) {
      this.querySelectorAll('[role="tab"]').forEach(button => {
        const active = button === tab;
        button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1;
        const panel = this.querySelector(`[id="${button.getAttribute('aria-controls')}"]`);
        if (panel) panel.hidden = !active;
      });
    }
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-rt-guide-link]');
    if (!link) return;
    if (link.closest('quick-add-modal') && link.pathname !== window.location.pathname) return;
    const target = document.getElementById(link.hash.slice(1));
    const guide = target?.matches('rt-product-guide') ? target : target?.querySelector('rt-product-guide');
    if (guide?.querySelector('dialog')?.showModal) { event.preventDefault(); guide.open(link); }
  });
})();
